import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from "react-intl";
import { Link } from 'react-router-dom';
import * as paths from '@app/constants/paths';
import Datetime from "react-datetime";
import dayjs from "dayjs";
// nodejs library that concatenates classes
import classNames from "classnames";
import LinearProgress from '@material-ui/core/LinearProgress';
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
// components
import GridContainer from '@app/components/Grid/GridContainer';
import GridItem from '@app/components/Grid/GridItem';
import Card from '@app/components/Card/Card';
import CardHeader from '@app/components/Card/CardHeader';
import CardBody from '@app/components/Card/CardBody';
import CardFooter from '@app/components/Card/CardFooter';
import CustomInput from '@app/components/CustomInput/CustomInput';
import Button from '@app/components/CustomButtons/Button';
import CustomAccordion from "@app/components/Accordion/CustomAccordion";
// material-ui-core
import InputAdornment from "@material-ui/core/InputAdornment";
import Radio from '@material-ui/core/Radio';
import Typography from '@material-ui/core/Typography';
// icons
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
// FontIcons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//styles
import withStyles from '@material-ui/core/styles/withStyles';
import surveyPageStyle from '@app/assets/jss/material-kit-pro-react/views/surveyPageStyle';

const DescribeYourBusinessView = (props) => {
    const classes = props.classes;
    // Validation messages
    // Business Description
    const bizActivitiesError = props.validationErrors.bizActivities.show;
    const bizActivitiesHelperText = props.validationErrors.bizActivities.show ? props.validationErrors.bizActivities.errorMessage : '';

    // Previous Project
    const previousProjectDeliverablesError = props.validationErrors.previousProjectDeliverables.show;
    const previousProjectDeliverablesHelperText = props.validationErrors.previousProjectDeliverables.show ? props.validationErrors.previousProjectDeliverables.errorMessage : '';
    // Previous Beneficiary
    const prevNameError = props.validationErrors.prevName.show;
    const prevNameHelperText = props.validationErrors.prevName.show ? props.validationErrors.prevName.errorMessage : '';

    const prevAmountError = props.validationErrors.prevAmount.show;
    const prevAmountHelperText = props.validationErrors.prevAmount.show ? props.validationErrors.prevAmount.errorMessage : '';
    // Options Messages
    const yes = props.intl.formatMessage({ id: "yes" });
    const no = props.intl.formatMessage({ id: "no" });
    const notSure = props.intl.formatMessage({ id: "not.sure" });
    
    // Date vars
    const today = dayjs();
    const validPreviousVoucherDate = function( current ) {
        return today.isAfter( current );
    };
    return (
            <GridContainer justify='center'>
                <GridItem xs={12}>
                    <form name="trading-online-voucher-scheme-2020">    
                        <Card className={classes.cardSignUp}>
                            <CardHeader color='danger' className={classes.cardHeaderSignUp}>
                                <h3 className={classNames(classes.cardTitle, classes.title)} id="bizDescription">
                                    DESCRIBE YOUR BUSINESS
                                </h3>
                            </CardHeader>
                            <CardBody className={classes.cardBodySignUp}>                                    
                                <h4 className={classes.title} id="bizActivities">
                                    Description Of Your Business Activities&nbsp;
                                    {props.validationErrors.bizActivities.check === null ? ' ' : (props.validationErrors.bizActivities.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                </h4>
                                <GridContainer justify='center'>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <CustomAccordion
                                            active={1}
                                            activeColor="danger"
                                            collapses={[
                                                {
                                                    title: "Help",
                                                    content:
                                                    "Overview of your business activities, whether related to the project or not. You must describe the products that you sell or the services that you provide."
                                                }
                                            ]}
                                        />
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <CustomInput
                                            id='bizActivitiesInput'
                                            labelText=''
                                            helperText={bizActivitiesHelperText}
                                            error={bizActivitiesError}
                                            formControlProps={{
                                                fullWidth: true
                                            }}
                                            inputProps={{
                                                multiline: true,
                                                rows: 6,
                                                name: 'bizActivities',
                                                value: props.bizActivities,
                                                onChange: props.handleBizActivities,
                                                autoComplete: 'off',
                                                startAdornment: (
                                                    <InputAdornment position='start'>
                                                        <FontAwesomeIcon icon={['fas', 'cart-plus']} className={classes.inputIconsColor} />
                                                    </InputAdornment>
                                                )
                                            }}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <h4 className={classes.title} id="prevVoucher">
                                    Have You Previously Received TOV Funding?&nbsp;
                                    {props.validationErrors.prevVoucher.check === null ? ' ' : (props.validationErrors.prevVoucher.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                </h4>
                                <GridContainer justify='center'>
                                    <GridItem xs={12} sm={12} md={8}>
                                        <CustomAccordion
                                            active={1}
                                            activeColor="danger"
                                            collapses={[
                                                {
                                                    title: "Help",
                                                    content:
                                                    "You must indicate Yes if you have previously received funding under the Trading Online Voucher Scheme. If you are not sure, you better get sure before you apply!"
                                                }
                                            ]}
                                        />
                                    </GridItem>
                                </GridContainer>
                                <GridContainer justify='center'>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <div className={classes.choice}>
                                            <FormControlLabel
                                                control={<Radio
                                                    onChange={props.handlePrevVoucher}
                                                    checkedIcon={
                                                        <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} className={classes.iconCheckboxIcon} />
                                                    }
                                                    icon={
                                                        <FontAwesomeIcon icon={['fas', 'chalkboard-teacher']} className={classes.iconCheckboxIcon} />
                                                    }
                                                    classes={{
                                                        checked: classes.iconCheckboxChecked,
                                                        root: classes.iconCheckbox
                                                    }}
                                                    checked={props.prevVoucher === 'yes'}
                                                    name="yes"
                                                />}
                                                classes={{ label: classes.label }}
                                                label={<Typography className={classes.formControlLabel}>{yes}</Typography>}
                                                labelPlacement="bottom"
                                                value="yes"
                                            />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <div className={classes.choice}>
                                            <FormControlLabel
                                                control={<Radio
                                                    onChange={props.handlePrevVoucher}
                                                    checkedIcon={
                                                        <FontAwesomeIcon icon={['fas', 'money-check']} className={classes.iconCheckboxIcon} />
                                                    }
                                                    icon={
                                                        <FontAwesomeIcon icon={['fas', 'money-check']} className={classes.iconCheckboxIcon} />
                                                    }
                                                    classes={{
                                                    checked: classes.iconCheckboxChecked,
                                                    root: classes.iconCheckbox
                                                    }}
                                                    name="no"
                                                    checked={props.prevVoucher === 'no'}
                                                />}
                                                classes={{ label: classes.label }}
                                                label={<Typography className={classes.formControlLabel}>{no}</Typography>}
                                                labelPlacement="bottom"
                                                value="no"
                                            />
                                        </div>
                                    </GridItem>
                                    <GridItem xs={12} sm={6} md={4}>
                                        <div className={classes.choice}>
                                            <FormControlLabel
                                                control={<Radio
                                                    onChange={props.handlePrevVoucher}
                                                    checkedIcon={
                                                        <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                    }
                                                    icon={
                                                        <FontAwesomeIcon icon={['fas', 'question']} className={classes.iconCheckboxIcon} />
                                                    }
                                                    classes={{
                                                        checked: classes.iconCheckboxChecked,
                                                        root: classes.iconCheckbox
                                                    }}
                                                    name="notSure"
                                                    checked={props.prevVoucher === 'notSure'}
                                                />}
                                                classes={{ label: classes.label }}
                                                label={<Typography className={classes.formControlLabel}>{notSure}</Typography>}
                                                labelPlacement="bottom"
                                                value="notSure"
                                            />
                                        </div>
                                    </GridItem>
                                </GridContainer>
                                <hr/>
                                {props.prevVoucher !== 'no' &&
                                    <div>
                                        <h4 className={classes.title} id="previousProjectDeliverables">
                                            Previous Project Deliverables&nbsp;
                                            {props.validationErrors.previousProjectDeliverables.check === null ? ' ' : (props.validationErrors.previousProjectDeliverables.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                        </h4>
                                        <GridContainer justify='center'>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <CustomAccordion
                                                    active={1}
                                                    activeColor="danger"
                                                    collapses={[
                                                        {
                                                            title: "Help",
                                                            content:
                                                            "If you have already been the beneficiary of a voucher under this scheme, describe the work you completed with the voucher."
                                                        }
                                                    ]}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <CustomInput
                                                    id='previousProjectDeliverablesInput'
                                                    labelText=''
                                                    helperText={previousProjectDeliverablesHelperText}
                                                    error={previousProjectDeliverablesError}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        multiline: true,
                                                        rows: 6,
                                                        name: 'previousProjectDeliverables',
                                                        value: props.previousProjectDeliverables,
                                                        onChange: props.handlePreviousProjectDeliverables,
                                                        autoComplete: 'off',
                                                        startAdornment: (
                                                            <InputAdornment position='start'>
                                                                <FontAwesomeIcon icon={['fas', 'business-time']} className={classes.inputIconsColor} />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <h4 className={classes.title} id="prevName">
                                            Name of beneficiary&nbsp;
                                            {props.validationErrors.prevName.check === null ? ' ' : (props.validationErrors.prevName.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                        </h4>
                                        <GridContainer justify='center'>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <CustomAccordion
                                                    active={1}
                                                    activeColor="danger"
                                                    collapses={[
                                                        {
                                                            title: "Help",
                                                            content:
                                                            "The name of the beneficiary on the previous Trading Online Voucher."
                                                        }
                                                    ]}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <CustomInput
                                                    id='prevNameInput'
                                                    labelText=''
                                                    helperText={prevNameHelperText}
                                                    error={prevNameError}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        name: 'prevName',
                                                        value: props.prevName,
                                                        onChange: props.handlePrevName,
                                                        autoComplete: 'off',
                                                        startAdornment: (
                                                            <InputAdornment position='start'>
                                                                <FontAwesomeIcon icon={['fas', 'signature']} className={classes.inputIconsColor} />
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <h4 className={classes.title} id="prevDate">
                                            Date of voucher letter&nbsp;
                                            {props.validationErrors.prevDate.check === null ? ' ' : (props.validationErrors.prevDate.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                        </h4>
                                        <GridContainer justify='center'>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <CustomAccordion
                                                    active={1}
                                                    activeColor="danger"
                                                    collapses={[
                                                        {
                                                            title: "Help",
                                                            content:
                                                            "The name of the beneficiary on the previous Trading Online Voucher."
                                                        }
                                                    ]}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <FormControl fullWidth>
                                                    <Datetime
                                                        timeFormat={false}
                                                        inputProps={{ 
                                                            placeholder: "Select Date",
                                                            value: dayjs(props.prevDate).format('dddd, MMM D, YYYY')
                                                        }}
                                                        onChange={props.handlePrevDate}
                                                        closeOnSelect={true}
                                                        locale="en-ie"
                                                        isValidDate={validPreviousVoucherDate}
                                                    />
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <h4 className={classes.title} id="prevAmount">
                                            Amount Claimed on Previous Voucher&nbsp;
                                            {props.validationErrors.prevAmount.check === null ? ' ' : (props.validationErrors.prevAmount.check ? <CheckIcon htmlColor="green" fontSize="large"/> : <ClearIcon htmlColor="red" fontSize="large"/>)}
                                        </h4>
                                        <GridContainer justify='center'>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <CustomAccordion
                                                    active={1}
                                                    activeColor="danger"
                                                    collapses={[
                                                        {
                                                            title: "Help",
                                                            content:
                                                            "The name of the beneficiary on the previous Trading Online Voucher."
                                                        }
                                                    ]}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer justify='center'>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <CustomInput
                                                    id='prevAmountInput'
                                                    labelText=''
                                                    helperText={prevAmountHelperText}
                                                    error={prevAmountError}
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        placeholder: '2500',
                                                        name: 'prevAmount',
                                                        value: props.prevAmount,
                                                        onChange: props.handlePrevAmount,
                                                        autoComplete: 'off',
                                                        startAdornment: (
                                                            <InputAdornment position='start'>
                                                                <FontAwesomeIcon icon={['fas', 'euro-sign']} className={classes.inputIconsColor} />
                                                            </InputAdornment>
                                                        ),
                                                        type: 'number'
                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>
                                    </div>
                                }
                            </CardBody>         
                            <CardFooter className={classes.cardFooterSignUp}>
                                <div className={classes.cardBodySignUpButtons}>
                                    <Button color="gray" component={ Link } to={paths.HELPER_T_O_V_S}>
                                        Main Menu
                                    </Button>
                                    <Button
                                        color="primary"
                                        size="sm"
                                        startIcon={<SaveIcon />}
                                        onClick={props.generateDoc}
                                    >
                                        Download
                                    </Button>
                                </div>
                            </CardFooter>
                            <CardFooter className={classes.cardFooterSignUp}>
                                <div className={classes.cardBodySignUpButtons}>
                                    <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_ABOUT}>
                                        &lt; About Your Business 
                                    </Button>
                                    <Button color='primary' component={ Link } to={paths.HELPER_T_O_V_S_PROJECT}>
                                        Project Description &gt;
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </form>
                </GridItem>
            </GridContainer>
    );
}

DescribeYourBusinessView.propTypes = {
    
    locale: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
    // Business Description
    handleBizActivities: PropTypes.func.isRequired,
    // Previous Project
    handlePrevVoucher: PropTypes.func.isRequired,
    handlePreviousProjectDeliverables: PropTypes.func.isRequired,
    handlePrevName: PropTypes.func.isRequired,
    handlePrevDate: PropTypes.func.isRequired,
    handlePrevAmount: PropTypes.func.isRequired,
    validationErrors: PropTypes.object.isRequired,
    generateDoc: PropTypes.func.isRequired
};

export default injectIntl(withStyles(surveyPageStyle)(DescribeYourBusinessView));